export default __webpack_public_path__ + "static/media/ic_ftm_40.e99561c6.svg";